var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHobbyDevelopmentInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.006 11.614-.034-1a1 1 0 0 0-.965.965l1 .035Zm11.38 11.379.036 1a1 1 0 0 0 .964-.965l-1-.035ZM1.042 12.613a9.97 9.97 0 0 1 7.423 2.923l1.415-1.414a11.97 11.97 0 0 0-8.907-3.508l.07 1.999Zm7.423 2.923a9.97 9.97 0 0 1 2.923 7.422l1.999.07a11.97 11.97 0 0 0-3.507-8.906l-1.415 1.414Zm3.888 6.457a9.97 9.97 0 0 1-7.423-2.922l-1.415 1.414a11.97 11.97 0 0 0 8.907 3.507l-.07-1.999ZM4.93 19.071a9.97 9.97 0 0 1-2.923-7.423l-1.999-.07a11.97 11.97 0 0 0 3.507 8.907L4.93 19.07Zm6.683-18.065-.035-1a1 1 0 0 0-.964.965l.999.035Zm11.38 11.38.035.999a1 1 0 0 0 .964-.965l-.999-.035ZM11.648 2.005a9.97 9.97 0 0 1 7.423 2.922l1.414-1.414A11.97 11.97 0 0 0 11.578.007l.07 1.999Zm7.423 2.922a9.97 9.97 0 0 1 2.923 7.422l1.998.07a11.97 11.97 0 0 0-3.507-8.906l-1.414 1.414Zm3.887 6.458a9.97 9.97 0 0 1-7.423-2.923l-1.414 1.414a11.97 11.97 0 0 0 8.907 3.508l-.07-2Zm-7.423-2.923a9.97 9.97 0 0 1-2.923-7.422L10.614.97a11.97 11.97 0 0 0 3.507 8.906l1.414-1.414Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobbyDevelopmentInactive);
export default __webpack_public_path__ + "static/media/hobby-development-inactive.15e1afedc1807d6f6bea7e6f95acf645.svg";
export { ForwardRef as ReactComponent };